import { render, staticRenderFns } from "./annoncesCommerciaux.vue?vue&type=template&id=2af08b2a&scoped=true&"
import script from "./annoncesCommerciaux.vue?vue&type=script&lang=js&"
export * from "./annoncesCommerciaux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af08b2a",
  null
  
)

export default component.exports